<!--
  ~ Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
  ~ Unauthorised copying of this file, via any medium is strictly prohibited
  ~ Proprietary and confidential
  ~ Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
  ~
  -->
<div *ngIf="!isLoading else loadingView">
    <form [formGroup]="siteForm">
        <acabim-form-block
            labelWidth="6"
            [labelAlign]="'right'"
            class="w-100"
            [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Site name</acabim-form-input-label>
                <acabim-form-input-content [longField]="true">
                    <input formControlName="siteName" type="text">
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <acabim-form-input-wrapper class="push-down-2">
                <acabim-form-input-label>Site address</acabim-form-input-label>
                <acabim-form-input-content class="w-100">
                    <acabim-map-viewer
                        #mapViewer
                        showControls="false"
                        [path]="mapCoordinates"
                        (selectedMapLocationChanged)="onMapLocationChanged($event)"></acabim-map-viewer>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
            <ng-container *ngIf="groups.length > 0">
                <acabim-form-input-wrapper [formGroup]="groupForm">
                    <acabim-form-input-label>Site groups</acabim-form-input-label>
                    <acabim-form-input-content [longField]="true">
                        <p-multiSelect [options]="groups" formControlName="selectedGroups"></p-multiSelect>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </ng-container>
        </acabim-form-block>
    </form>
    <div class="cas-action-buttons cas-action-buttons-bottom">
        <button (click)="onCancel()">Cancel</button>
        <button (click)="onSubmit()" class="cas-button-action cas-button-right">Add</button>
    </div>
    <div class="cas-alert" style="font-size:0.8rem;color: red;">NOTE: Make sure the site boundary is shown on the map before proceeding to create the site.</div>
</div>

<p-toast position="center"></p-toast>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>
